module.exports = __webpack_public_path__ + "img/kaspro.2000181e.png";